import styles from './HeadingShared.module.scss';
import { useContext, type ElementType, type ReactNode } from 'react';
import { HeadingContext } from './HeadingContext';
import { HeadingSpacing } from './HeadingSpacing';
import clsx from 'clsx';

export interface HeadingClassNames {
  end?: string;
  heading?: string;
  root?: string;
  start?: string;
}

interface Props {
  children: ReactNode;
  classNames?: HeadingClassNames;
  sub?: ReactNode;
  end?: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  start?: ReactNode;
  spacing?: HeadingSpacing;
}

export function HeadingShared(props: Props) {
  const context = useContext(HeadingContext);
  const resolvedLevel = props.level ?? context.level;
  const level = Math.min(Math.max(resolvedLevel, 1), 6);
  const spacing = props.spacing ?? 'both';
  const rootClassName = clsx(
    styles['root'],
    styles['level-' + level],
    styles['spacing-' + spacing],
    props.classNames?.root,
  );
  const headingClassName = clsx(styles['heading'], props.classNames?.heading);

  const Tag = `h${level}` as ElementType;
  const headingElement = (
    <Tag className={headingClassName}>{props.children}</Tag>
  );

  return (
    <div className={rootClassName}>
      {props.start && (
        <div className={clsx(styles['addon'], props.classNames?.start)}>
          {props.start}
        </div>
      )}
      <div className={styles['content']}>
        <div>{headingElement}</div>
        {props.sub && <div>{props.sub}</div>}
      </div>
      {props.end && (
        <div className={clsx(styles['addon'], props.classNames?.end)}>
          {props.end}
        </div>
      )}
    </div>
  );
}
